import type { CustomFontDefinition } from "@/types";

const createStyleElememt = (doc: Document, id: string, css: string) => {
  const fonts = doc.createElement('style');
  fonts.id = id;
  fonts.innerText = css;
  doc.head.appendChild(fonts);
};



export function useCustomFont(doc: Document | undefined | null, font: CustomFontDefinition) {
  // in case the iframes document is not available
  if (font.fontfaceCSS && doc) {
    createStyleElememt(doc, 'customfont', font.fontfaceCSS);
    if (font.fontSizeBase) {
      doc.documentElement.style.setProperty(
        '--moin-fontSizeBase',
        font.fontSizeBase,
      );
    }
  }
}
